import { defineStore } from 'pinia';

export const useProjectModifyViewStore = defineStore('projectModifyView', {
	state: () => {
		return {
			isTemplate: undefined as boolean | undefined,
			hasBackToBackPhases: undefined as boolean | undefined,
			projectStartDate: undefined as string | undefined,
			prevProjectStartDate: undefined as string | undefined,
			projectStartDays: undefined as string | undefined,
			projectDueDate: undefined as string | undefined,
			triggerSaveRetainerPeriods: undefined as boolean | undefined,
		};
	},
});

export const getProjectModifyViewStoreDefaultState = () => ({
	isTemplate: undefined as boolean | undefined,
	hasBackToBackPhases: undefined as boolean | undefined,
	projectStartDate: undefined as string | undefined,
	prevProjectStartDate: undefined as string | undefined,
	projectStartDays: undefined as string | undefined,
	projectDueDate: undefined as string | undefined,
	triggerSaveRetainerPeriods: undefined as boolean | undefined,
});
